import { WebFsError } from '#common/types';
export class HttpMetadataFetchError extends WebFsError {
}
export class HttpMetadataNetworkError extends HttpMetadataFetchError {
}
